export default {
    RESET_PASSWORD: 'reset_password',
    EMAIL_CONFIRMED: 'registration_confirmed',
    WEBMONEY_AUTH: 'webmoney_auth',
    INVOICE_REGISTRATION: 'invoice_registration',
    REGISTRATION_ALREADY_COMPLITED: 'registration_already_complited',
    PAYMENT_RESULT: 'payment_result',
};
